import { Badge, IconButton } from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { useRecoilValue } from 'recoil';
import { useThemeColor } from '../hooks/useThemeColor';
import { frontendSettingsAtom } from '../../../atoms/FrontendSettings';
import { EditableStyleWrapper } from '../StyleEditor/EditableStyleWrapper';

export const OffersButton = () => {
  const { primary, secondary } = useThemeColor();

  const settings = useRecoilValue(frontendSettingsAtom);

  return (
    <EditableStyleWrapper path='appHeaderSettings.iconStyle'>
      <IconButton>
        <EditableStyleWrapper path='appHeaderSettings.iconBadgeStyle'>
          <Badge
            badgeContent={3}
            sx={{
              '& .MuiBadge-badge': {
                color: secondary,
                backgroundColor: primary,
                ...settings.settingsV2?.appHeaderSettings?.iconBadgeStyle,
              },
            }}
            overlap='circular'
            style={{ transform: 'translate(25px, -15px)' }}
          />
        </EditableStyleWrapper>

        <LocalOfferIcon
          sx={{
            ...settings.settingsV2?.appHeaderSettings?.iconStyle,
          }}
        />
      </IconButton>
    </EditableStyleWrapper>
  );
};
